var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.301,
    height: 48.3,
    viewBox: "0 0 48.301 48.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15470",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15470",
    transform: "translate(-17846 -4318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15469",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15469",
    transform: "translate(45 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9457",
    "data-name": "\\u9577\\u65B9\\u5F62 9457",
    width: 48.3,
    height: 48.3,
    transform: "translate(17801 4263)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "chat_2_",
    "data-name": "chat (2)",
    d: "M35.327,8.943A18.63,18.63,0,0,0,8.967,6.307,18.839,18.839,0,0,0,6.331,32.855L2.565,36.621A1.139,1.139,0,0,0,2,37.75a1.779,1.779,0,0,0,1.883,1.883H20.829A18.419,18.419,0,0,0,32.691,35.3,18.63,18.63,0,0,0,35.327,8.943Z",
    transform: "translate(17849 4320.973)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButton);
export default __webpack_public_path__ + "static/media/chatButton.d24145cb51fad88b4d770cfb0d33418f.svg";
export { ForwardRef as ReactComponent };